import { APP_ICONS } from '../../static/appIcons.js';
import { NAVIGATION_PATHS } from '../../static/navigationPaths.js';

export const getDashboardCards = () => {
  return [
    {
      imgUrl: 'https://cdn.forge.tylertech.com/v1/images/spot/checklist-spot.svg',
      imgAlt: '',
      title: APP_ICONS.PROGRAM_INVENTORY,
      accessName: APP_ICONS.PROGRAM_INVENTORY,
      description: 'View, edit, and export a list of the programs and services you provide.',
      to: NAVIGATION_PATHS.PROGRAM_INVENTORY,
    },
    {
      imgUrl: 'https://cdn.forge.tylertech.com/v1/images/spot/money-spot.svg',
      imgAlt: '',
      title: APP_ICONS.COST_ALLOCATION,
      accessName: APP_ICONS.COST_ALLOCATION,
      description: 'Learn the true cost of each program by allocating your budget items.',
      to: NAVIGATION_PATHS.COST_ALLOCATION,
    },
    {
      imgUrl: 'https://cdn.forge.tylertech.com/v1/images/spot/punch-card-spot.svg',
      imgAlt: '',
      title: 'Program scoring',
      accessName: APP_ICONS.DEPARTMENT_SCORING,
      description: 'Assess each program according to universal attributes and identify each program\u0027s alignment with strategic priorities.',
      to: NAVIGATION_PATHS.DEPARTMENT_SCORING,
    },
    {
      imgUrl: 'https://cdn.forge.tylertech.com/v1/images/spot/data-points-spot.svg',
      imgAlt: '',
      title: APP_ICONS.DATA_VISUALIZATION,
      accessName: APP_ICONS.DATA_VISUALIZATION,
      description: 'Use charts, tables, and filters to visualize your complete PBB dataset and support transparent decision-making.',
      to: NAVIGATION_PATHS.DATA_VISUALIZATIONS,
    },
    {
      imgUrl: 'https://cdn.forge.tylertech.com/v1/images/spot/captive-insurance-spot.svg',
      imgAlt: '',
      title: APP_ICONS.PROGRAM_INSIGHTS,
      accessName: APP_ICONS.PROGRAM_INSIGHTS,
      description: 'Store, discuss, and evaluate opportunities to improve program delivery and create efficiencies.',
      to: NAVIGATION_PATHS.PROGRAM_INSIGHTS,
    },
    {
      imgUrl: 'https://cdn.forge.tylertech.com/v1/images/spot/add-generic-spot.svg',
      imgAlt: '',
      title: APP_ICONS.BUDGET_REQUESTS,
      accessName: APP_ICONS.BUDGET_REQUESTS,
      description: 'Connect requests to allocation and scoring data to justify budget changes.',
      to: NAVIGATION_PATHS.BUDGET_REQUESTS,
    },
  ];
};

export const getTodaysDate = () => {
  let date = new Date();
  let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  return date.toLocaleDateString('en-US', options);
};
